// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"tooltip_Tooltip__31DFu","Body":"tooltip_Body__1OARg","Text":"tooltip_Text__1S0Sk"};